import { useEffect, useState } from 'react';
import type { FileSummary } from '../../shared/types';
import { optimizeItemIcon, type OptimizedItemIcon } from '../lib/item-icon';

export function CombatIconPicker({ label, icon, value, onChange, disabled=false }: { label:string; icon:FileSummary|null; value:OptimizedItemIcon|null; onChange:(value:OptimizedItemIcon|null)=>void; disabled?:boolean }) {
  const [preview,setPreview]=useState<string|null>(null);
  const [error,setError]=useState<string|null>(null);
  useEffect(()=>()=>{ if(preview) URL.revokeObjectURL(preview); },[preview]);
  async function choose(file:File|null){
    if(!file){onChange(null);setPreview(null);return;}
    try{
      setError(null);
      const optimized=await optimizeItemIcon(file);
      onChange(optimized);
      if(preview)URL.revokeObjectURL(preview);
      setPreview(URL.createObjectURL(optimized.icon));
    }catch(e){setError(e instanceof Error?e.message:'Icon konnte nicht verarbeitet werden.');}
  }
  const existing=icon ? `${icon.thumbnailUrl ?? icon.downloadUrl}?v=${encodeURIComponent(icon.id)}` : null;
  return <div className="field-callout">
    <strong>{label}</strong>
    <div className="form-grid two compact-fields">
      <div className="thumb">{preview||existing?<img src={preview??existing??''} alt="Icon-Vorschau"/>:<img src="/assets/potion.svg" alt="Platzhalter"/>}</div>
      <label>PNG auswählen<input disabled={disabled} type="file" accept="image/png,image/webp" onChange={(e)=>void choose(e.target.files?.[0]??null)}/><small className="field-help">Wird automatisch als 512×512 PNG plus 128×128 Thumbnail optimiert. Ohne Icon nutzt Unreal/UI einen Platzhalter.</small>{error&&<small className="field-error">{error}</small>}</label>
    </div>
  </div>;
}
